module.exports = __webpack_public_path__ + "static/media/Rubik-Medium.72602f5d.otf";